// sanitize-utils.js
// Utility functions for sanitizing user input

/**
 * Sanitizes a string by removing or escaping dangerous characters.
 * Prevents XSS and unwanted input (e.g., <, >, ", ', &).
 * @param {string} str
 * @returns {string}
 */
export function sanitizeInput(str) {
    if (typeof str !== 'string') return '';
    // Remove < and > and optionally other dangerous characters
    return str.replace(/[<>"'&]/g, '');
}

/**
 * Checks if a character is forbidden for input (e.g., <, >, ", ', &)
 * @param {string} key
 * @returns {boolean}
 */
export function isForbiddenChar(key) {
    return /[<>"]|'|&/.test(key);
}

/**
 * Sanitizes pasted content by removing forbidden characters
 * @param {string} str
 * @returns {string}
 */
export function sanitizePaste(str) {
    return typeof str === 'string' ? str.replace(/[<>"]|'|&/g, '') : '';
} 